var BindingCount = {
    MultipleBindingsAvailable: 2,
    NoBindingsAvailable: 0,
    OnlyOneBindingAvailable: 1
};
export { BindingCount };
//# sourceMappingURL=binding_count.js.map